import { JobseekerProfileState } from "./state";
import { createImmerReducer } from 'ngrx-immer/store';
import * as JobseekerProfileActions from './actions';
import { on, Action } from '@ngrx/store';
import { JobseekerEducationModel } from 'src/app/jobseeker/shared/services/jobseeker.service';
import * as RootActions from "../../actions";
import { state } from "@angular/animations";
import { EducationLevelEnum, Jobseeker, JobseekerSkillItem, SkillBaseTypeEnum } from "@hrra/common-models";
import { JobseekerExtendedLocationModel } from "src/app/shared/models/jobseeker-location.model";

let initialState: JobseekerProfileState = {
    jobseeker: null,
    loading: false,
    updateLoading: false,
    attachmentLoading: false,
    fileUploading: false,
    isEmailChangeRequested: false,
    file: null,
    isFileSizeValid: true,
    isWorkExperienceFormSubmitted: false,

    educationUiState: {
        selectedJobseekerEducation: null,
        isInstitutionSelectModeOn: null,
        isProgramSelectModeOn: null,
    },

    skillsUiState: {
        currentSkillBaseType: null,
        draftSkills: [],
        suggestions: null,
        suggestionsLoading: false,
    },

    workExperienceUiState: {
        workExperience: null,
        currentSelectedCategories: [],
        isCurrent: false,
        currentSelectedIndustries: [],
        extendedLocationCounter: 1,
        extendedLocations: [{
            jobseekerExtendedLocationId: null,
            jobseekerId: null,
            lastVisibleLocationId: null,
            locationId: null
        }],
        currentSelectedSpecializations: [],
        selectedSeniorityLevelId: null,
        selectedEmploymentTypeId: null,
        selectedWorkScheduleId: null,
        selectedEmploymentFormNewId: null,
    },
    
    photoState: {
        isPhotoSelected: false,
        isPhotoApproved: false,
        base64: null
    },

    personalInfoState: {
        selectedMonth: null,
        selectedYear: null,
        selectedAddress: null,
        selectedLegalAddress: null,
        selectedSameAsCurrentAddress: null
    },
    
    cvExportState: {
        loading: false,
        cvExportFailureDetails: null
    }
}

const reducer = createImmerReducer(
    initialState,
    on(JobseekerProfileActions.loadJobseekerProfileForAdmin, state =>{
        state.loading = true;
        return state;
    }),
    on(JobseekerProfileActions.loadJobseekerProfileForAdminSuccess, (state, {payload}) => {
        state.jobseeker = payload;
        state.personalInfoState.selectedMonth = payload.birthMonth;
        state.personalInfoState.selectedYear = payload.birthYear;
        state.personalInfoState.selectedAddress = payload.address;
        state.personalInfoState.selectedLegalAddress = payload.legalAddress;
        state.personalInfoState.selectedSameAsCurrentAddress = payload.sameAsCurrentAddress;
        state.loading = false;
        return state;
    }),
    on(JobseekerProfileActions.loadJobseekerProfileForAdminFail, (state, {payload}) => {
        state.loading = false;
        return state;
    }),

    on(RootActions.logoutSuccess, (state, _) => {
        Object.assign(state, initialState);
        return state;
    }),

    //delete
    on(JobseekerProfileActions.deleteJobseekerDocument, (state, {payload}) => {
        state.updateLoading = true;
        return state;
    }),
    on(JobseekerProfileActions.deleteJobseekerDocumentSuccess, (state, {payload}) => {
        state.updateLoading = false;
        state.jobseeker = payload;
        return state;
    }),
    on(JobseekerProfileActions.deleteJobseekerDocumentFail, (state, {payload}) => {
        state.updateLoading = false;
        return state;
    }),

    on(JobseekerProfileActions.deleteJobseekerLanguage, state => {
        state.updateLoading = true;
        return state;
    }),
    on(JobseekerProfileActions.deleteJobseekerLanguageSuccess, (state, {payload}) => {
        state.updateLoading = false;
        state.jobseeker = payload;
        return state;
    }),
    on(JobseekerProfileActions.deleteJobseekerLanguageFail, (state, {payload}) => {
        state.updateLoading = false;
        return state;
    }),

    on(JobseekerProfileActions.deleteJobseekerEducationForAdmin, state => {
        state.updateLoading = true;
        return state;
    }),
    on(JobseekerProfileActions.deleteJobseekerEducationForAdminSuccess, (state, {payload}) => {
        state.updateLoading = false;
        state.jobseeker = payload;
        return state;
    }),
    on(JobseekerProfileActions.deleteJobseekerEducationForAdminFail, (state, {payload}) => {
        state.updateLoading = false;
        return state;
    }),

    on(JobseekerProfileActions.deleteJobseekerWorkExperienceForAdmin, state => {
        state.updateLoading = true;
        return state;
    }),
    on(JobseekerProfileActions.deleteJobseekerWorkExperienceForAdminSuccess, (state, {payload}) => {
        state.updateLoading = false;
        state.jobseeker = payload;
        return state;
    }),
    on(JobseekerProfileActions.deleteJobseekerWorkExperienceForAdminFail, (state, {payload}) => {
        state.updateLoading = false;
        return state;
    }),

    on(JobseekerProfileActions.deleteJobseekerPhoto, state => {
        state.updateLoading = true;
        return state;
    }),
    on(JobseekerProfileActions.deleteJobseekerPhotoSuccess, (state, {payload}) => {
        state.updateLoading = false;
        state.jobseeker = payload;
        return state;
    }),
    on(JobseekerProfileActions.deleteJobseekerPhotoFail, (state, {payload}) => {
        state.updateLoading = false;
        return state;
    }),


    //downloads
    on(JobseekerProfileActions.downloadEducationAttachmentForAdmin, state => {
        state.attachmentLoading = true;
        return state;
    }),
    on(JobseekerProfileActions.downloadEducationAttachmentForAdminSuccess, state => {
        state.attachmentLoading = false;
        return state;
    }),
    on(JobseekerProfileActions.downloadEducationAttachmentForAdminFail, (state, {payload}) => {
        state.attachmentLoading = false;
        return state;
    }),
    on(JobseekerProfileActions.downloadLanguageAttachmentForAdmin, state => {
        state.attachmentLoading = true;
        return state;
    }),
    on(JobseekerProfileActions.downloadLanguageAttachmentForAdminSuccess, state => {
        state.attachmentLoading = false;
        return state;
    }),
    on(JobseekerProfileActions.downloadLanguageAttachmentForAdminFail, (state, {payload}) => {
        state.attachmentLoading = false;
        return state;
    }),
    on(JobseekerProfileActions.downloadDocumentAttachmentFromAdmin, state => {
        state.attachmentLoading = true;
        return state;
    }),
    on(JobseekerProfileActions.downloadDocumentAttachmentFromAdminSuccess, state => {
        state.attachmentLoading = false;
        return state;
    }),
    on(JobseekerProfileActions.downloadDocumentAttachmentFromAdminFail, (state, {payload}) => {
        state.attachmentLoading = false;
        return state;
    }),
    on(JobseekerProfileActions.downloadWorkExperienceAttachmentForAdmin, state => {
        state.attachmentLoading = true;
        return state;
    }),
    on(JobseekerProfileActions.downloadWorkExperienceAttachmentForAdminSuccess, state => {
        state.attachmentLoading = false;
        return state;
    }),
    on(JobseekerProfileActions.downloadWorkExpeienceAttachmentForAdminFail, (state, {payload}) => {
        state.attachmentLoading = false;
        return state;
    }),


    //edit jobseeker
    on(JobseekerProfileActions.editJobseekerPersonalInfoForAdmin, state => {
        state.updateLoading = true;
        return state;
    }),
    on(JobseekerProfileActions.editJobseekerPersonalInfoForAdminSuccess, (state, {payload}) => {
        state.updateLoading = false;
        state.jobseeker = payload;
        return state;
    }),
    on(JobseekerProfileActions.editJobseekerPersonalInfoForAdminFail, (state, {payload}) => {
        state.updateLoading = false;
        return state;
    }),

    
    on(JobseekerProfileActions.editJobseekerEducationForAdmin, state => {
        state.updateLoading = true;
        return state;
    }),
    on(JobseekerProfileActions.editJobseekerEducationForAdminSuccess, (state, {payload}) => {
        state.updateLoading = false;
        state.jobseeker = payload;
        return state;
    }),
    on(JobseekerProfileActions.editJobseekerEducationForAdminFail, (state, {payload}) => {
        state.updateLoading = false;
        return state;
    }),
    on(JobseekerProfileActions.selectJobseekerEducationForAdmin, (state, {payload}) => {
        if(payload.objectId == null){
            let x: JobseekerEducationModel = <any>{};
            
            x.jobseekerEducationId = null;
            x.educationLevelId = null;
            x.educationalInstitutionId = null;
            x.educationalProgramId = null;
            x.educationalProgramName = null;
            x.institution = null;
            x.specialization = null;
            x.dateFromYear = null;
            x.dateFromMonth = null;
            x.dateToYear = null;
            x.dateToMonth = null;
            x.description = null;
            x.attachment = null;
            x.objectId = null;

            state.educationUiState.selectedJobseekerEducation = x;
        }

        else{
            let education = state.jobseeker.pendingModifiedJobseekerEducations.find(e => e.objectId == payload.objectId) ||
            state.jobseeker.jobseekerEducations.find(e => e.objectId == payload.objectId);

            let x: JobseekerEducationModel = <any>{};
            x.jobseekerEducationId = education?.jobseekerEducationId;
            x.educationLevelId = education?.educationLevel?.educationLevelId;
            x.educationalInstitutionId = education?.educationalInstitution?.educationalInstitutionId;
            x.educationalProgramId = education?.educationalProgram?.educationalProgramId;
            x.educationalProgramName = education?.educationalProgramName;
            x.institution = education?.institution;
            x.specialization = education?.specialization;
            x.dateFromYear = education?.dateFromYear;
            x.dateFromMonth = education?.dateFromMonth;
            x.dateToYear = education?.dateToYear;
            x.dateToMonth = education?.dateToMonth;
            x.description = education?.description;
            x.attachment = education?.attachment;
            x.objectId = education?.objectId;

            state.educationUiState.selectedJobseekerEducation = x;

            state.educationUiState.isInstitutionSelectModeOn = education.educationalInstitution != null;
            state.educationUiState.isProgramSelectModeOn = education.educationalProgram != null;
        }

        return state;
    }),
    on(JobseekerProfileActions.selectJobseekerEducationLevelForAdmin, (state, {payload}) => {
        state.educationUiState.selectedJobseekerEducation.educationLevelId = payload.levelId;
        if(payload.levelId == EducationLevelEnum.Bachelor || payload.levelId == EducationLevelEnum.Master || payload.levelId == EducationLevelEnum.Doctor || payload.levelId == EducationLevelEnum.College){
            state.educationUiState.isInstitutionSelectModeOn = true;
            state.educationUiState.isProgramSelectModeOn = true;
        }
        else{
            state.educationUiState.isInstitutionSelectModeOn = false;
            state.educationUiState.isProgramSelectModeOn = false;
        }
        return state;
    }),
    on(JobseekerProfileActions.institutionSelectModeForAdmin, state => {
        state.educationUiState.isInstitutionSelectModeOn = !state.educationUiState.isInstitutionSelectModeOn;
        if(!state.educationUiState.isInstitutionSelectModeOn){
            state.educationUiState.isProgramSelectModeOn = false;
        }
        return state;
    }),
    on(JobseekerProfileActions.programSelectModeForAdmin, state => {
        let programMode = state.educationUiState.isProgramSelectModeOn;
        state.educationUiState.isProgramSelectModeOn = !programMode;
        if(!programMode){
            state.educationUiState.isInstitutionSelectModeOn = true;
        }
        return state;
    }),
    on(JobseekerProfileActions.selectJobseekerEdcuationalInstitutionForAdmin, (state, {payload}) => {
        state.educationUiState.selectedJobseekerEducation.educationalInstitutionId = payload.institutionId;
        return state;
    }),
    on(JobseekerProfileActions.closeJobseekerEditEducationFormForAdmin, state => {
        state.educationUiState.selectedJobseekerEducation = null;
        state.educationUiState.isProgramSelectModeOn = null;
        state.educationUiState.isInstitutionSelectModeOn = null;
        state.file = null;
        state.isFileSizeValid = true;
        state.fileUploading = false;
        return state;
    }),

    on(JobseekerProfileActions.editJobseekerLanguageForAdmin, state => {
        state.updateLoading = true;
        return state;
    }),
    on(JobseekerProfileActions.editJobseekerLanguageForAdminSuccess, (state, {payload}) => {
        state.updateLoading = false;
        state.jobseeker = payload;
        return state;
    }),
    on(JobseekerProfileActions.editJobseekerLanguageForAdminFail, (state, {payload}) => {
        state.updateLoading = false;
        return state;
    }),
    on(JobseekerProfileActions.closeJobseekerEditLanguageFormForAdmin, state => {
        state.file = null;
        state.isFileSizeValid = true;
        state.fileUploading = false;
        return state;
    }),
    on(JobseekerProfileActions.editJobseekerWorkExperienceForAdmin, state => {
        state.updateLoading = true;
        return state;
    }),
    on(JobseekerProfileActions.editJobseekerWorkExperienceForAdminSuccess, (state, {payload}) => {
        state.updateLoading = false;
        state.jobseeker = payload;
        return state;
    }),
    on(JobseekerProfileActions.editJobseekerWorkExperienceForAdminFail, (state, {payload}) => {
        state.updateLoading = false;
        return state;
    }),
    on(JobseekerProfileActions.setJobseekerWorkExperienceForAdmin, (state, { payload }) => {
        state.workExperienceUiState.workExperience = payload;

        if (payload != null){
            state.workExperienceUiState.currentSelectedIndustries = payload?.industries;
            state.workExperienceUiState.currentSelectedSpecializations = payload?.specializations;
            state.workExperienceUiState.selectedSeniorityLevelId = payload?.seniorityLevelId;
            state.workExperienceUiState.selectedWorkScheduleId = payload?.workScheduleId;
            state.workExperienceUiState.selectedEmploymentFormNewId = payload?.employmentFormId;
            state.workExperienceUiState.selectedEmploymentTypeId = payload?.employmentFormTypeId;
            }
            state.workExperienceUiState.isCurrent = payload?.isCurrent;
    
        return state;
    }),
    on(JobseekerProfileActions.setSelectedSpecializationsForAdmin, (state, { payload }) => {
        state.workExperienceUiState.currentSelectedSpecializations = payload;
        return state;
    }),
    on(JobseekerProfileActions.updateEmploymentFormTypeForAdmin, (state, { payload }) => {
        state.workExperienceUiState.selectedEmploymentTypeId = payload.employmentTypeId;
        return state;
    }),
    on(JobseekerProfileActions.updateSeniorityLevelIdForAdmin, (state, { payload }) => {
        
        state.workExperienceUiState.selectedSeniorityLevelId = payload.seniorityLevelId;
        return state;
    }),
    on(JobseekerProfileActions.setSelectedIndustriesForAdmin, (state, {payload}) => {
        state.workExperienceUiState.currentSelectedIndustries = payload
        return state
    }),
    on(JobseekerProfileActions.updateEmploymentFormNewIdForAdmin, (state, { payload }) => {
            state.workExperienceUiState.selectedEmploymentFormNewId = payload.employmentFormNewId;
            return state;
        }),
    on(JobseekerProfileActions.updateWorkScheduleIdForAdmin, (state, { payload }) => {
            state.workExperienceUiState.selectedWorkScheduleId = payload.workScheduleId;
            return state;
    }),
    on(JobseekerProfileActions.closeWorkExperienceEditFormForAdmin, state => {
        state.workExperienceUiState.currentSelectedCategories = [];
        state.workExperienceUiState.currentSelectedSpecializations = [];
        state.workExperienceUiState.selectedEmploymentTypeId = null;
        state.workExperienceUiState.selectedSeniorityLevelId = null;
        state.workExperienceUiState.selectedWorkScheduleId = null;
        state.workExperienceUiState.selectedEmploymentFormNewId = null;
        state.workExperienceUiState.isCurrent = false;
        state.workExperienceUiState.workExperience = null;
        state.file = null;
        state.isFileSizeValid = true;
        state.fileUploading = false;
        return state;
    }),
    on(JobseekerProfileActions.changeWorkExperienceIsCurrentForAdmin, state => {
        state.workExperienceUiState.isCurrent = !state.workExperienceUiState.isCurrent;
        return state;
    }),
    on(JobseekerProfileActions.workExperienceFormSubmit, (state, {payload}) => {
        state.isWorkExperienceFormSubmitted = payload;
        return state;
    }),
    on(JobseekerProfileActions.setIsWorkExperienceFilledForAdmin, (state, { payload }) => {
        state.updateLoading = true;
        return state;
    }),
    on(JobseekerProfileActions.setIsWorkExperienceFilledForAdminSuccess, (state, { payload }) => {
        state.jobseeker = payload;
        state.updateLoading = false;
        return state;
    }),
    on(JobseekerProfileActions.setIsWorkExperienceFilledForAdminFail, (state, { payload }) => {
        state.updateLoading = false;
        return state;
    }),
    // location

    on(JobseekerProfileActions.addLocation, (state) => {
        state.workExperienceUiState.extendedLocationCounter++;
        
        const extendendLocation = <JobseekerExtendedLocationModel>{
            jobseekerId: 0,
            jobseekerExtendedLocationId: 0,
            locationId: null,
            lastVisibleLocationId: null,
        };

        state.workExperienceUiState.extendedLocations.push(extendendLocation);
        return state;
    }),
    on(JobseekerProfileActions.removeLocation, (state, {payload}) => {
        state.workExperienceUiState.extendedLocationCounter--;
        state.workExperienceUiState.extendedLocations = state.workExperienceUiState.extendedLocations.filter((item, index) => index !== payload.index);
        return state;
    }),

    //file upload
    on(JobseekerProfileActions.uploadTempFileForAdmin, (state, {payload}) => {
        state.fileUploading = true;
        return state;
    }),
    on(JobseekerProfileActions.uploadTempFileForAdminSuccess, (state, {payload}) => {
        state.fileUploading = false;
        state.file = payload;
        return state;
    }),
    on(JobseekerProfileActions.uploadTempFileForAdminFail, (state, {payload}) => {
        state.fileUploading = false;
        return state;
    }),
    on(JobseekerProfileActions.closeJobseekerUploadDocumentFormForAdmin, state => {
        state.file = null;
        state.isFileSizeValid = true;
        state.fileUploading = false;
        return state;
    }),
    on(JobseekerProfileActions.setFileSizeValidation, (state, { payload }) => {
        state.isFileSizeValid = payload;
        if(!payload){
            state.file = null
        }
        return state;
    }),

    //document upload
    on(JobseekerProfileActions.uploadJobseekerDocumentForAdmin, (state, {payload}) => {
        state.updateLoading = true;
        return state;
    }),
    on(JobseekerProfileActions.uploadJobseekerDocumentForAdminSuccess, (state, {payload}) => {
        state.updateLoading = false;
        state.jobseeker = payload;
        return state;
    }),
    on(JobseekerProfileActions.uploadJobseekerDocumentForAdminFail, (state, {payload}) => {
        state.updateLoading = false;
        return state;
    }),

    //edit photo
    on(JobseekerProfileActions.editJobseekerPhotoForAdmin, (state, { payload }) => {
        state.updateLoading = true;
        return state;
    }),
    on(JobseekerProfileActions.editJobseekerPhotoForAdminSuccess, (state, { payload }) => {
        state.updateLoading = false;
        state.jobseeker = payload;
        return state;
    }),
    on(JobseekerProfileActions.editJobseekerPhotoForAdminFail, (state, { payload }) => {
        state.updateLoading = false;
        return state;
    }),
    on(JobseekerProfileActions.insertCroppedImageForAdmin, (state, { payload }) => {
        state.photoState.base64 = payload.base64;
        return state;
    }),
    on(JobseekerProfileActions.selectJobseekerPhotoForAdmin, state => {
        state.photoState.isPhotoSelected = true;
        return state;
    }),
    on(JobseekerProfileActions.closeJobseekerPhotoEditFormForAdmin, state => {
        state.photoState.isPhotoApproved = false;
        state.photoState.isPhotoSelected = false;
        state.photoState.base64 = null;
        return state;
    }),
    on(JobseekerProfileActions.approveJobseekerPhotoForAdmin, state => {
        state.photoState.isPhotoApproved = true;
        state.photoState.isPhotoSelected = false;
        return state;
    }),
    on(JobseekerProfileActions.setSelectedBirthMonth, (state, { payload }) => {
        state.personalInfoState.selectedMonth = payload;
        return state;
    }),
    on(JobseekerProfileActions.setSelectedBirthYear, (state, { payload }) => {
        state.personalInfoState.selectedYear = payload;
        return state;
    }),
    on(JobseekerProfileActions.updateJobseekerAddress, (state, {payload}) => {
        state.personalInfoState.selectedAddress = payload;
        return state;
    }),
    on(JobseekerProfileActions.updateSameAsCurrentAddress, (state, {payload}) => {
        state.personalInfoState.selectedSameAsCurrentAddress = payload;
        return state;
    }),
    on(JobseekerProfileActions.updateJobseekerLegalAddress, (state, {payload}) => {
        state.personalInfoState.selectedLegalAddress = payload;
        return state;
    }),

    //cvExport
    on(JobseekerProfileActions.jobseekerCvExport, state => {
        state.cvExportState.loading = true;
        return state;
    }),
    on(JobseekerProfileActions.jobseekerCvExportSuccess, state => {
        state.cvExportState.loading = false;
        return state;
    }),
    on(JobseekerProfileActions.jobseekerCvExportFailed, (state, { payload }) => {
        state.cvExportState.loading = false;
        state.cvExportState.cvExportFailureDetails = payload;
        return state;
    }),

    //skills
    on(JobseekerProfileActions.openJobseekerSkillsFormForAdmin, (state, {payload}) => {
        state.skillsUiState.currentSkillBaseType = payload.skillBaseType;
        state.skillsUiState.draftSkills = getSavedSkills(state.jobseeker, payload.skillBaseType)
            .slice()
            .sort((a, b) => a.index - b.index)
            .map(s => ({
                canonicalSkillId: s.skillId,
                name: s.name ? s.name : s.userProvidedText,
                isCustom: s.skillId == null
            }));
        state.skillsUiState.suggestions = null;
        return state;
    }),
    on(JobseekerProfileActions.closeJobseekerSkillsFormForAdmin, state => {
        state.skillsUiState.currentSkillBaseType = null;
        state.skillsUiState.draftSkills = [];
        state.skillsUiState.suggestions = null;
        state.skillsUiState.suggestionsLoading = false;
        return state;
    }),
    on(JobseekerProfileActions.loadSkillSuggestionsForAdmin, state => {
        state.skillsUiState.suggestionsLoading = true;
        return state;
    }),
    on(JobseekerProfileActions.loadSkillSuggestionsForAdminSuccess, (state, {payload}) => {
        state.skillsUiState.suggestions = payload;
        state.skillsUiState.suggestionsLoading = false;
        return state;
    }),
    on(JobseekerProfileActions.loadSkillSuggestionsForAdminFail, state => {
        state.skillsUiState.suggestionsLoading = false;
        return state;
    }),
    on(JobseekerProfileActions.addJobseekerSkillForAdmin, (state, {payload}) => {
        let skills = state.skillsUiState.draftSkills;
        if(!skills.some(s => s.canonicalSkillId == payload.skill.skillId || s.name.toLowerCase() == payload.skill.name.toLowerCase())){
            skills.push({
                canonicalSkillId: payload.skill.skillId,
                name: payload.skill.name,
                isCustom: false
            });
        }

        let suggestions = state.skillsUiState.suggestions;
        if(suggestions){
            suggestions.queryResultItems = suggestions.queryResultItems?.filter(i => i.skillId != payload.skill.skillId);
            suggestions.suggestedItems = suggestions.suggestedItems?.filter(i => i.skillId != payload.skill.skillId);
        }
        return state;
    }),
    on(JobseekerProfileActions.addCustomJobseekerSkillForAdmin, (state, {payload}) => {
        let skills = state.skillsUiState.draftSkills;
        let name = payload.name?.trim();
        if(name && !skills.some(s => s.name.toLowerCase() == name.toLowerCase())){
            skills.push({
                canonicalSkillId: null,
                name: name,
                isCustom: true
            });
        }
        return state;
    }),
    on(JobseekerProfileActions.removeJobseekerSkillForAdmin, (state, {payload}) => {
        state.skillsUiState.draftSkills.splice(payload.index, 1);
        return state;
    }),
    on(JobseekerProfileActions.reorderJobseekerSkillsForAdmin, (state, {payload}) => {
        moveSkill(state.skillsUiState.draftSkills, payload.previousIndex, payload.currentIndex);
        return state;
    }),
    on(JobseekerProfileActions.saveJobseekerSkillsForAdmin, state => {
        state.updateLoading = true;
        return state;
    }),
    on(JobseekerProfileActions.saveJobseekerSkillsForAdminSuccess, (state, {payload}) => {
        state.updateLoading = false;
        state.jobseeker = payload;
        return state;
    }),
    on(JobseekerProfileActions.saveJobseekerSkillsForAdminFail, state => {
        state.updateLoading = false;
        return state;
    })
);

//saved skills live on the jobseeker model, split by skill base type
function getSavedSkills(jobseeker: Jobseeker, skillBaseType: SkillBaseTypeEnum): JobseekerSkillItem[]{
    return (skillBaseType === SkillBaseTypeEnum.Hard ? jobseeker?.hardSkills : jobseeker?.softSkills) ?? [];
}

function moveSkill<T>(skills: T[], previousIndex: number, currentIndex: number){
    if(previousIndex === currentIndex){
        return;
    }
    let [skill] = skills.splice(previousIndex, 1);
    skills.splice(currentIndex, 0, skill);
}

export function jobseekerProfileForAdminReducer(state: JobseekerProfileState | undefined, action: Action) {
    return reducer(state, action);
}

